import React, { useState } from "react";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "../components/ui/card";
import arbitrageIcon from "../assets/images/arbitrage.svg";
import newStatus from "../assets/icons/new_status_tag.svg";
import pending from "../assets/icons/pending-tag-big.svg";
import active from "../assets/icons/active-tag-big.svg";
import comingSoon from "../assets/icons/coming-soon-tag.svg";
import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import ArbitrageOverview from "./ArbitrageOverview";
import { ArbitrageHistory } from "./ArbitrageHistory";
import InvestFaq from "./InvestFaq";
import { InvestSummary } from "./InvestSummary";
import { SearchIcon } from "lucide-react";
import { Button } from "./ui/button";
import { Separator } from "./ui/separator";
export default function InvestArbitrage() {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState();
  const [page, setPage] = useState(0);
  const [projectStatus, setProjectStatus] = useState("new");
  const [status, setStatus] = useState("pending");
  const [open1, setIsOpen1] = useState(true);
  const [open2, setIsOpen2] = useState(false);
  const [open3, setIsOpen3] = useState(false);

  return (
    <>
      {(() => {
        if (page == "0") {
          return (
            <div className="col-span-4 px-8">
              <div className="py-3 mb-2">
                <Card className="bg-white rounded-2xl shadow-sm py-3 mb-4">
                  <CardHeader className="mb-4  px-6">
                    <div className="relative ">
                      {(() => {
                        if (
                          projectStatus == "new" &&
                          status != "pending" &&
                          status != "active"
                        ) {
                          return (
                            <img
                              src={newStatus}
                              alt="Status Icon"
                              className="absolute top-[15px] right-0"
                            />
                          );
                        } else if (
                          projectStatus == "comingsoon" &&
                          status != "pending" &&
                          status != "active"
                        ) {
                          return (
                            <img
                              src={comingSoon}
                              alt="Status Icon"
                              className="absolute top-[15px] right-0"
                            />
                          );
                        } else if (status == "pending" || status != "active") {
                          return (
                            <img
                              src={pending}
                              alt="Status Icon"
                              className="absolute top-[15px] right-0"
                            />
                          );
                        } else if (status != "pending" || status == "active") {
                          return (
                            <img
                              src={active}
                              alt="Status Icon"
                              className="absolute top-[15px] right-0"
                            />
                          );
                        }
                      })()}
                    </div>
                    <CardTitle className="text-[20px] font-semibold text-text-secondary">
                      <div className="flex items-center">
                        <div className="mr-5">
                          <img src={arbitrageIcon} alt="Arbitrage Icon" />
                        </div>
                        <div>
                          <div className="flex justify-between">
                            <h2 className="text-[32px] text-text-primary font-bold">
                              Multi-asset arbitrage
                            </h2>
                          </div>
                          <p className="text-[16px] text-text-secondary font-normal">
                            Earn low-risk returns through the price fluctuations
                            of different cryptocurrencies.
                          </p>
                        </div>
                      </div>
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="px-6 pb-6 outline outline-gray-50 rounded-lg outline-1">
                    <div className="mb-2">
                      <h4 className="text-[14px] text-text-secondary font-semibold mb-2">
                        Investment details
                      </h4>
                      <div className="">
                        <div className="flex items-center justify-between px-3 py-3 border rounded-t-lg">
                          <p className="text-[14px] text-text-primary font-normal">
                            Opening deposit
                          </p>
                          <p className="text-[16px] text-text-primary font-semibold">
                            R 100K – R 1M
                          </p>
                        </div>
                        <div className="flex items-center justify-between px-3 py-3 border-r border-l border-b">
                          <p className="text-[14px] text-text-primary font-normal">
                            ROI
                          </p>
                          <p className="text-[16px] text-text-primary font-semibold">
                            10.0%
                          </p>
                        </div>
                        <div className="flex items-center justify-between px-3 py-3 border-r border-l border-b">
                          <p className="text-[14px] text-text-primary font-normal">
                            Duration
                          </p>
                          <p className="text-[16px] text-text-primary font-semibold">
                            365 days
                          </p>
                        </div>
                        <div className="flex items-center justify-between px-3 py-3 border-r border-l">
                          <p className="text-[14px] text-text-primary font-normal">
                            Risk
                          </p>
                          <p className="text-[16px] text-text-primary font-semibold">
                            Low
                          </p>
                        </div>
                        <div className="flex items-center justify-between px-3 py-3 border rounded-b-lg">
                          <p className="text-[14px] text-text-primary font-normal">
                            Minimum investment
                          </p>
                          <p className="text-[16px] text-text-primary font-semibold">
                            R 100 000
                          </p>
                        </div>
                      </div>
                      {(() => {
                        if (status == "active") {
                          return (
                            <div className="flex items-center justify-center mt-10">
                              <Button
                                variant="outline"
                                className="py-6 px-32 text-sm font-bold text-text-secondary rounded-full bg-transparent hover:opacity-90 hover:text-text-secondary"
                              >
                                Generate report
                              </Button>
                            </div>
                          );
                        } else if (status == "pending") {
                          return <></>;
                        } else {
                          return (
                            <div className="flex items-center justify-center mt-10">
                              <p className="text-[14px] text-accent-pink font-semibold mr-6">
                                Terms and conditions
                              </p>
                              <Button
                                variant="outline"
                                className="py-6 px-32 text-sm font-bold text-white rounded-full bg-gradient-to-r from-purple-500 to-rose-600 hover:opacity-90 hover:text-white"
                              >
                                {projectStatus == "new"
                                  ? "Apply now"
                                  : "Notify me"}
                              </Button>
                            </div>
                          );
                        }
                      })()}
                    </div>
                  </CardContent>
                  {status == "active" ||
                    (status == "pending" && (
                      <>
                        <Separator />
                        <div className="flex justify-center items-center pt-7 pb-4">
                          <p className="text-sm text-gray-500 mr-2">
                            Questions?{" "}
                          </p>
                          <a
                            className="font-bold text-rose-500 hover:underline"
                            onClick={() => {
                              navigate("/support/whatsapp");
                            }}
                          >
                            Contact us
                          </a>
                        </div>
                      </>
                    ))}
                </Card>

                {(() => {
                  if (status == "active") {
                    return <ArbitrageHistory setPage={setPage} />;
                  } else if (
                    projectStatus == "new" ||
                    projectStatus == "comingsoon" ||
                    (status == "pending" &&
                      status != "active" &&
                      status == null)
                  ) {
                    return <InvestFaq />;
                  }
                })()}
              </div>
            </div>
          );
        } else if (page == 1) {
          return <ArbitrageOverview />;
        }
      })()}
    </>
  );
}
